import { Injectable, isDevMode } from '@angular/core';
import { EMPTY, Subject } from 'rxjs';
import { map } from 'rxjs/internal/operators/map';
import { tap } from 'rxjs/internal/operators/tap';
import { ConfigTurnsDaoService } from 'src/app/dao/turns-dao-services/config-turns-dao-service/config-turns-dao.service';
import { UserService } from '../../user-service/user.service';
import { UserStorageService } from '../../user-storage-service/user-storage.service';

@Injectable({
  providedIn: 'root'
})
export class ConfigTurnsService {

  accessToken = 'TUR';
  private refreshTurnsConfigListener = new Subject<any>();

  constructor(private turnsConfigDaoService: ConfigTurnsDaoService,
              private userStorageService: UserStorageService,
              private userService: UserService) { }

  public getTurnsConfig() {
    if (this.userService.accessGranted(this.accessToken)) {
      return this.turnsConfigDaoService.getTurnsConfig(this.userStorageService.getContext(), this.userStorageService.getLang(), this.userStorageService.getUDID()).pipe(
        tap(o => !isDevMode() || console.dir(o)),
        map(o => o['data']['config'])
      );
    }
    return EMPTY;
  }

  public updateTurnsConfigHelp(assistantActive) {
    if (this.userService.accessGranted(this.accessToken)) {
      return this.turnsConfigDaoService.updateTurnsConfigHelp(this.userStorageService.getContext(), this.userStorageService.getLang(), this.userStorageService.getUDID(), assistantActive).pipe(
        tap(o => !isDevMode() || console.dir(o)),
        map(o => o)
      );
    }
    return EMPTY;
  }

  public updateTurnsConfigUI(broadcastingMode, languageIconMode, backgroundColor, textPrimaryColor, textSecondaryColor, takeTurnsFromBroadcast) {
    if (this.userService.accessGranted(this.accessToken)) {
      return this.turnsConfigDaoService.updateTurnsConfigUI(
        this.userStorageService.getContext(),
        this.userStorageService.getLang(),
        this.userStorageService.getUDID(),
        broadcastingMode,
        languageIconMode,
        backgroundColor,
        textPrimaryColor,
        textSecondaryColor,
        takeTurnsFromBroadcast
      ).pipe(
        tap(o => !isDevMode() || console.dir(o)),
        map(o => o)
      );
    }
    return EMPTY;
  }

  public getTurnsCenterConfig(centerInternalId) {
    if (this.userService.accessGranted(this.accessToken)) {
      return this.turnsConfigDaoService.getTurnsCenterConfig(
        this.userStorageService.getContext(),
        this.userStorageService.getLang(),
        this.userStorageService.getUDID(),
        centerInternalId
      ).pipe(
        tap(o => !isDevMode() || console.dir(o)),
        map(o => o['data'] && o['data']['config'] ? o['data']['config'] : (o['data'] ? o['data'] : o))
      );
    }
    return EMPTY;
  }

  public updateTurnsCenterConfig(centerInternalId, workingMode) {
    if (this.userService.accessGranted(this.accessToken)) {
      return this.turnsConfigDaoService.updateTurnsCenterConfig(
        this.userStorageService.getContext(),
        this.userStorageService.getLang(),
        this.userStorageService.getUDID(),
        centerInternalId,
        workingMode
      ).pipe(
        tap(o => !isDevMode() || console.dir(o)),
        map(o => o)
      );
    }
    return EMPTY;
  }

  public updateTurnsUiBackgroundImage(backgroundImageUrl) {
    if (this.userService.accessGranted(this.accessToken)) {
      return this.turnsConfigDaoService.updateTurnsUiBackgroundImage(
        this.userStorageService.getContext(),
        this.userStorageService.getLang(),
        this.userStorageService.getUDID(),
        backgroundImageUrl
      ).pipe(
        tap(o => !isDevMode() || console.dir(o)),
        map(o => o)
      );
    }
    return EMPTY;
  }

  public updateTurnsConfigSatisfaction(satisfactionActive) {
    if (this.userService.accessGranted(this.accessToken)) {
      return this.turnsConfigDaoService.updateTurnsConfigSatisfaction(this.userStorageService.getContext(), this.userStorageService.getLang(), this.userStorageService.getUDID(), satisfactionActive).pipe(
        tap(o => !isDevMode() || console.dir(o)),
        map(o => o)
      );
    }
    return EMPTY;
  }

  public updateTurnsConfigImageTicket(imageTicket) {
    if (this.userService.accessGranted(this.accessToken)) {
      return this.turnsConfigDaoService.updateTurnsConfigImageTicket(this.userStorageService.getContext(), this.userStorageService.getLang(), this.userStorageService.getUDID(), imageTicket).pipe(
        tap(o => !isDevMode() || console.dir(o)),
        map(o => o)
      );
    }
    return EMPTY;
  }

  public listenRefreshTurnsConfigListener() {
    return this.refreshTurnsConfigListener.asObservable();
  }

  public refreshTurnsConfig() {
    this.refreshTurnsConfigListener.next();
  }
}
